import { useEffect, useState } from "react";
import useFlow from "../hooks/useFlow";
import moment from "moment-timezone";

export default function Clock() {
  const { timezoneRef, isDebugOn, setIsDebugOn } = useFlow();

  useEffect(() => {
    const intervalId = setInterval(updateClock, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getCurrentTime = () => {
    const now = new moment().tz(timezoneRef.current);
    let hours = now.get("hours");
    const minutes = now.get("minutes");
    const ampm = hours >= 12 ? "pm" : "am";

    hours = hours % 12 || 12;

    const formattedTime = `${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}${ampm}`;

    return formattedTime;
  };

  const [currentTime, setCurrentTime] = useState(getCurrentTime());

  const updateClock = () => {
    setCurrentTime(getCurrentTime());
  };

  const toggleDebug = () => {
    setIsDebugOn(!isDebugOn);
  };

  return (
    <>
      <div className="d-none d-md-block clock opacity-50" onClick={toggleDebug}>
        {currentTime}
      </div>
      <div className="position-fixed top-0 end-0">
        {isDebugOn && (
          <p onClick={toggleDebug}>
            <span className="badge rounded-pill text-bg-success">Debug</span>
          </p>
        )}
      </div>
    </>
  );
}
